
export const ADDTOCART = "api/add-to-cart-manage";
export const POSTSList = "api/post-list";
export const PRODUCTDETAIL = "api/product-details";
export const PRODUCTList = "api/product-list";
export const PRODUCTDEPENDENTCATEGORY = "api/product-dependent-list";
export const PRODUCTCATEGORY = "api/product-category-list"
export const PRODUCTSEARCH = "api/search";
export const SOCIALLOGIN = "api/social-login";
export const WISHLIST = "api/product-like-wishlist";
